module.exports = __webpack_public_path__ + "static/media/companies.5b8c8abc.jpeg";